import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useUser } from '../UserContext';
import { useNavigate, Link } from 'react-router-dom';
import './index.css';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from '../../imagens/Sem fundo.png';

const Relatorio = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();

    const [clientes, setClientes] = useState([]);
    const [dados, setDados] = useState([]);
    const [loading, setLoading] = useState(false);

    // Estados dos Filtros Adicionais
    const [filterRota, setFilterRota] = useState('');
    const [filterStatusCli, setFilterStatusCli] = useState('');
    const [filterStatusFin, setFilterStatusFin] = useState('');
    const [filterDias, setFilterDias] = useState('');
    const [filterPositivo, setFilterPositivo] = useState('');
    const [filterVendedor, setFilterVendedor] = useState('');

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCliente, setSelectedCliente] = useState(null);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [abaSelecionada, setAbaSelecionada] = useState('analiseClientes');

    const [loadingClientes, setLoadingClientes] = useState(true);
    const [agendamentosReais, setAgendamentosReais] = useState({});
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [selectedAppointmentDate, setSelectedAppointmentDate] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalAgendamento, setshowModalAgendamento] = useState(false);

    const [dataAgendamento, setDataAgendamento] = useState('');
    const [horaAgendamento, setHoraAgendamento] = useState('');
    const [descricaoAgendamento, setDescricaoAgendamento] = useState('');
    const [ageTipoAtendimento, setAgeTipoAtendimento] = useState('');
    const [motivoAgendamento, setMotivoAgendamento] = useState('');    
    const [atendenteVendedor, setAtendenteVendedor] = useState('');
    const [dadosVendedor, setDadosVendedor] = useState([]);
    const [vendedorSelecionado, setVendedorSelecionado] = useState([]);
    const [dadosAlteradosAgendamento, setDadosAlteradosAgendamento] = useState([]);
    const [vendedorCadastro, setVendedorCadastro] = useState('');
    const [vendedorAnalise, setVendedorAnalise] = useState([]);

  // Verificação de login
  useEffect(() => {
    if (!userInfo?.username || !userInfo?.company) {
      localStorage.removeItem('userInfo');
      navigate('/home');
    }
  }, [userInfo, navigate]);

  const credentials = btoa(`${userInfo?.alias};${userInfo?.venLogin}:${userInfo?.venSenha}`);

  const handleSelectCliente = (cliente) => {
    setSelectedCliente(cliente);
    setSearchTerm(cliente.colNome);
    setShowSuggestions(false);
  };

  const filteredClientes = clientes.filter((c) => {
    const termo = searchTerm.toLowerCase();
    return (
      c.cliId?.toString().includes(termo) ||
      c.colNome?.toLowerCase().includes(termo) ||
      c.colFantasia?.toLowerCase().includes(termo) ||
      c.colCnpjCpf?.toLowerCase().includes(termo)
    );
  });

  // Buscar clientes
  useEffect(() => {
    const fetchClientes = async () => {
      if (!userInfo?.url) return;
      
      try {
        const res = await fetch(`${userInfo.url}/cliente`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          }
        });

        const text = await res.text();
        const safeText = text.replace(/\u00A0/g, ' ').trim();
        const json = JSON.parse(safeText);
        setClientes(json);
      } catch (err) {
        console.error('Erro ao buscar clientes:', err);
      }
    };

    const extrairVendedoresUnicos = (dadosRecebidos) => {
    const mapa = new Map();
    
    dadosRecebidos.forEach(item => {
      // Só adiciona se o venId existir e ainda não estiver no mapa
      if (item.venId && !mapa.has(item.venId)) {
        mapa.set(item.venId, { 
          venId: item.venId, 
          vendedor: item.venId + ' - ' + item.vendedor || 'Não informado',
        });
      }
    });
    
    return Array.from(mapa.values()).sort((a, b) => {
    return parseInt(a.venId) - parseInt(b.venId);
    });
  };

  // Função para buscar dados do relatório
  const fetchDados= async () => {
    setLoading(true);
    try {
      const res = await fetch(`${userInfo.url}/subgrupomarca`, {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Accept': 'application/json; charset=utf-8',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
      });
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const text = await res.text();
      // ✅ SOLUÇÃO DO ERRO 500/JSON: Remove caracteres de controle (quebras de linha, tabs, etc)
      //const safeText = text.replace(/[\r\n\t]/g, " ").replace(/\u00A0/g, ' ').trim();
      const safeText = text.replace(/[\r\n\t]/g, " ").replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);

      setDados(json);

      const vendedoresUnicos = extrairVendedoresUnicos(json);
      setVendedorAnalise(vendedoresUnicos);

      return json;
      
    } catch (err) {
      console.error('❌ Erro ao buscar dados:', err);
      return [];
    } finally {
      setLoading(false);
    }
    };

    fetchClientes();
    fetchDados();

  }, [userInfo, credentials]);

  // Lógica de filtragem da tabela
  const dadosFiltradosTable = useMemo(() => {
    return dados.filter(item => {
      const matchCliente = !selectedCliente || item.cliId === selectedCliente.cliId;
      const matchRota = !filterRota || (item.cliRota && item.cliRota.toLowerCase().includes(filterRota.toLowerCase()));
      const matchStatusCli = !filterStatusCli || item.statusCliente === filterStatusCli;
      const matchStatusFin = !filterStatusFin || item.statusFinanceiro === filterStatusFin;
      const matchDias = !filterDias || item.diasSemCompra >= parseInt(filterDias);
      const matchPositivo = !filterPositivo || item.clientePositivo === filterPositivo;
      const matchVendedor = !filterVendedor || String(item.venId) === String(filterVendedor);

      return matchCliente && matchRota && matchStatusCli && matchStatusFin && matchDias && matchPositivo && matchVendedor;
    });
  }, [dados, selectedCliente, filterRota, filterStatusCli, filterStatusFin, filterDias, filterPositivo, filterVendedor]);

  const gerarPDF = () => {
    const doc = new jsPDF('l', 'mm', 'a4');
    doc.text(`Relatório CRM - Análise de Clientes - ${userInfo.company}`, 14, 10);
    
    const tableColumn = ["ID", "Nome", "Rota", "Lmt Crédito", "Utilizado", "Status Cli", "Status Fin", "Dias S/C", "Positivo", "id Vendedor", "Vendedor"];
    const tableRows = dadosFiltradosTable.map(item => [
      item.cliId,
      item.colNome,
      item.cliRota || '-',
      item.vlrCredito?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      item.limiteUtilizado?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      item.statusCliente,
      item.statusFinanceiro,
      item.diasSemCompra,
      item.clientePositivo,
      item.venId,
      item.vendedor
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 15,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [41, 128, 185] },
    });

    doc.save(`CRM-Analyse-${new Date().toLocaleDateString().replace(/\//g, '-')}.pdf`);
  };

    // Função para buscar agendamentos da API
    const fetchAgendamentos = useCallback(async () => {
        setLoadingClientes(true);
        try {
            if (!userInfo || !userInfo.company || !userInfo.venLogin || !userInfo.venSenha) {
                throw new Error('Informações de login incompletas');
            }

            const empresa = userInfo.company.split(' ')[0];
            const credentials = btoa(`${empresa};${userInfo.venLogin}:${userInfo.venSenha}`);
            const url = `${userInfo.url}/agendamento`;

            const headers = {
                'Content-Type': 'application/json',
                'empresa': userInfo.alias,
                'Authorization': `Basic ${credentials}`,
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: headers
            });

            if (!response.ok) throw new Error(`Erro HTTP: ${response.status}`);

            const dados = await response.json();

            if (Array.isArray(dados)) {
                if (dados.length === 0) {
                    setAgendamentosReais({});
                } else {
                    const agendamentosProcessados = processarAgendamentos(dados);
                    setAgendamentosReais(agendamentosProcessados);
                }
            } else {
                setAgendamentosReais({});
            }
        } catch (error) {
            console.error('❌ Erro ao buscar agendamentos:', error);
        } finally {
            // Adicionado fechamento do finally
        } 
    }, [userInfo]); // FIX: Fechamento correto do useCallback e parênteses

    // Função para processar os dados da API para o formato do calendário
    const processarAgendamentos = (dados) => {
        const agendamentos = {};
        const vendedoresUnicos = new Map();
        const vendedoresUnicos2 = new Map();

        if (!Array.isArray(dados)) return agendamentos;

        dados.forEach((item, index) => {
            if (!item.ageDtaAgendamento) return;

            // Armazena o vendedor na lista de únicos se ele existir
            if (item.venId && item.nomeVendedor) {
                vendedoresUnicos.set(item.venId, {
                    venId: item.venId,
                    nome: item.nomeVendedor
                });
            }

            if (item.venId && item.nomeVendedor) {
                vendedoresUnicos2.set(item.venId, {
                    venId: item.venId,
                    nome: item.nomeVendedor
                });
            }

            try {
                const partes = item.ageDtaAgendamento.split('T');
                const dataAgendamento = partes[0];
                const horaAgendamento = partes[1] ? partes[1].substring(0, 5) : '00:00';

                const agendamento = {
                    id: item.ageId || index + 1,
                    cliente: item.nomeCliente || 'Cliente não informado',
                    hora: horaAgendamento,
                    descricao: item.ageObservacao || 'Sem descrição',
                    status: item.ageStatusVenda,
                    tipo: item.ageTipoAtendimento,
                    motivo: item.ageMotivoVisita,
                    funcionario: item.nomeFunc || 'Não atribuído',
                    vendedor: item.nomeVendedor || 'Não informado',
                    vendedorId: item.venId || 'Não informado',
                    atendente: item.nomeFunc || 'Não informado',
                    geolocalizacao: item.geolocalizacao || 'Não informado',
                    // Corrigido: de '=' para ':'
                    dadosVendedor: { 
                        nome: item.nomeVendedor,
                        venId: item.venId,
                    }
                };

                if (!agendamentos[dataAgendamento]) {
                    agendamentos[dataAgendamento] = [];
                }
                agendamentos[dataAgendamento].push(agendamento);
              } catch (dateError) {
                console.error(`Erro ao processar data:`, dateError);
            }
        });
        setDadosVendedor(Array.from(vendedoresUnicos.values()));
        setVendedorSelecionado(Array.from(vendedoresUnicos2.values()));
        return agendamentos;
    };
  
    // Carregar agendamentos quando o userInfo estiver disponível
    useEffect(() => {
      if (userInfo && userInfo.venLogin && !loadingClientes) {
        fetchAgendamentos();
      }
    }, [userInfo, loadingClientes, fetchAgendamentos]);
  
    const formatDate = (date) => {
      // Corrigido: não usar toISOString aqui, pois ele pode mudar o dia se for perto da meia-noite
      // devido ao fuso horário. Pegamos as partes locais do objeto.
      const ano = date.getFullYear();
      const mes = String(date.getMonth() + 1).padStart(2, '0');
      const dia = String(date.getDate()).padStart(2, '0');
      return `${ano}-${mes}-${dia}`;
    };
  
    const getDaysInMonth = (date) => {
      const year = date.getFullYear();
      const month = date.getMonth();
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);
      const daysInMonth = lastDay.getDate();
      const startingDayOfWeek = firstDay.getDay();
  
      const days = [];
      
      // Adiciona dias vazios do início
      for (let i = 0; i < startingDayOfWeek; i++) {
        days.push(null);
      }
      
      // Adiciona todos os dias do mês
      for (let day = 1; day <= daysInMonth; day++) {
        days.push(new Date(year, month, day));
      }
      
      return days;
    };
  
    const openModal = (appointment, date) => {
      setSelectedAppointment(appointment);
      setSelectedAppointmentDate(date);
      setShowModal(true);
    };
  
    const closeModal = () => {
      setShowModal(false);
      setSelectedAppointment(null);
      setSelectedAppointmentDate(null);
      setshowModalAgendamento(false);
      setSelectedCliente(null);
      setSearchTerm('');
      setShowSuggestions(false);
      setDataAgendamento('');
      setHoraAgendamento('');
      setDescricaoAgendamento('');
      setAgeTipoAtendimento('');
      setMotivoAgendamento('');
      setDadosAlteradosAgendamento([]);
    };
  
    const handleAgendamentoSubmit = async () => {
      if (!selectedCliente) {
        alert('Por favor, selecione um cliente.');
        return;
      }
      if (!dataAgendamento || !horaAgendamento) {
        alert('Por favor, preencha a data e o horário do agendamento.');
        return;
      }
      if (!ageTipoAtendimento || ageTipoAtendimento === '') {
        alert('Por favor, selecione o tipo de atendimento.');
        return;
      }
      if (!motivoAgendamento || motivoAgendamento === '') {
        alert('Por favor, selecione o motivo do agendamento.');
        return;
      }
      if (!descricaoAgendamento || descricaoAgendamento === '') {
        alert('Por favor, preencha a descrição do agendamento.');
        return;
      } 
  
      try {
        const payload = {
          AGE_STATUS_VENDA: 'Agendado',
          AGE_MOTIVO_VISITA: motivoAgendamento,
          AGE_TIPO_ATENDIMENTO: ageTipoAtendimento,
          AGE_OBSERVACAO: descricaoAgendamento,
          FUN_ID: Number(userInfo.ven_id),
          AGE_DTA_AGENDAMENTO: `${dataAgendamento}T${horaAgendamento}`,
          CLI_ID: Number(selectedCliente.cliId),
          VEN_ID: Number(userInfo.ven_id),
        };
  
        console.log('🚀 Payload montado para envio:', payload);
  
        const response = await fetch(`${userInfo.url}/agendamento`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
          body: JSON.stringify(payload),
        });
  
        if (response.ok) {
          alert('Agendamento realizado com sucesso!');
          setshowModalAgendamento(false);
          fetchAgendamentos(); // Atualiza a lista de agendamentos
        } else {
          const errorData = await response.text();
          console.error('❌ Resposta de erro do servidor:', errorData);
          alert('Erro ao realizar agendamento (Status 500). Verifique o console.');
        }
      } catch (error) {
        console.error('❌ Erro na requisição POST:', error);
        alert('Erro ao realizar agendamento. Verifique a conexão.');
      }
    };
  
  const finalizarAgendamento = async () => { 

  try {
      const payload = {
      AGE_STATUS_VENDA: 'Finalizado',
      AGE_MOTIVO_VISITA: dadosAlteradosAgendamento.motivo || selectedAppointment.motivo,
      AGE_TIPO_ATENDIMENTO: dadosAlteradosAgendamento.tipo || selectedAppointment.tipo,
      AGE_OBSERVACAO: dadosAlteradosAgendamento.descricao || selectedAppointment.descricao,
      FUN_ID: Number(dadosAlteradosAgendamento.atendente || selectedAppointment.venId),
      VEN_ID: Number(dadosAlteradosAgendamento.atendente || selectedAppointment.venId),
      AGE_DTA_AGENDAMENTO: `${dadosAlteradosAgendamento.data || selectedAppointmentDate}T${dadosAlteradosAgendamento.hora || selectedAppointment.hora}`,
    };

      console.log('🚀 Payload montado para final:', payload);

      // 2. O FETCH precisa de AWAIT
      const response = await fetch(`${userInfo.url}/agendamento/${selectedAppointment.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
        body: JSON.stringify(payload),
      });

      // 3. A verificação da resposta
      if (response.ok) {
        alert('Serviço finalizado com sucesso!');
        //console.log('✅ Resposta do servidor:', await response.json());
        closeModal();
        fetchAgendamentos();
      } else {
        // Aqui também precisa de AWAIT
        const errorData = await response.text(); 
        //console.error('❌ Resposta de erro do servidor:', errorData);
        alert(`Erro do servidor: ${errorData}`);
      }
    } catch (error) {
      console.error('❌ Erro na requisição PUT:', error);
      alert('Erro ao finalizar serviço. Verifique o console.');
    }
  };

  const salvarAgendamento = async () => { 

  try {
      const payload = {
      AGE_STATUS_VENDA: selectedAppointment.status || 'Agendado',
      AGE_MOTIVO_VISITA: dadosAlteradosAgendamento.motivo || selectedAppointment.motivo,
      AGE_TIPO_ATENDIMENTO: dadosAlteradosAgendamento.tipo || selectedAppointment.tipo,
      AGE_OBSERVACAO: dadosAlteradosAgendamento.descricao || selectedAppointment.descricao,
      FUN_ID: Number(dadosAlteradosAgendamento.atendente || selectedAppointment.venId),
      VEN_ID: Number(dadosAlteradosAgendamento.atendente || selectedAppointment.venId),
      AGE_DTA_AGENDAMENTO: `${dadosAlteradosAgendamento.data || selectedAppointmentDate}T${dadosAlteradosAgendamento.hora || selectedAppointment.hora}`,
    };

      console.log('🚀 Payload montado para final:', payload);

      // 2. O FETCH precisa de AWAIT
      const response = await fetch(`${userInfo.url}/agendamento/${selectedAppointment.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
        body: JSON.stringify(payload),
      });

      // 3. A verificação da resposta
      if (response.ok) {
        alert('Serviço salvo com sucesso!');
        //console.log('✅ Resposta do servidor:', await response.json());
        closeModal();
        fetchAgendamentos();
      } else {
        // Aqui também precisa de AWAIT
        const errorData = await response.text(); 
        //console.error('❌ Resposta de erro do servidor:', errorData);
        alert(`Erro do servidor: ${errorData}`);
      }
    } catch (error) {
      console.error('❌ Erro na requisição PUT:', error);
      alert('Erro ao finalizar serviço. Verifique o console.');
    }
  };

  const cancelarAgendamento = async () => { 

  try {
      const payload = {
      AGE_STATUS_VENDA: 'Cancelado',
      AGE_MOTIVO_VISITA: dadosAlteradosAgendamento.motivo || selectedAppointment.motivo,
      AGE_TIPO_ATENDIMENTO: dadosAlteradosAgendamento.tipo || selectedAppointment.tipo,
      AGE_OBSERVACAO: dadosAlteradosAgendamento.descricao || selectedAppointment.descricao,
      FUN_ID: Number(dadosAlteradosAgendamento.atendente || selectedAppointment.venId),
      VEN_ID: Number(dadosAlteradosAgendamento.atendente || selectedAppointment.venId),
      AGE_DTA_AGENDAMENTO: `${dadosAlteradosAgendamento.data || selectedAppointmentDate}T${dadosAlteradosAgendamento.hora || selectedAppointment.hora}`,
    };

      console.log('🚀 Payload montado para final:', payload);

      // 2. O FETCH precisa de AWAIT
      const response = await fetch(`${userInfo.url}/agendamento/${selectedAppointment.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
        body: JSON.stringify(payload),
      });

      // 3. A verificação da resposta
      if (response.ok) {
        alert('Serviço Cancelado com sucesso!');
        //console.log('✅ Resposta do servidor:', await response.json());
        closeModal();
        fetchAgendamentos();
      } else {
        // Aqui também precisa de AWAIT
        const errorData = await response.text(); 
        //console.error('❌ Resposta de erro do servidor:', errorData);
        alert(`Erro do servidor: ${errorData}`);
      }
    } catch (error) {
      console.error('❌ Erro na requisição PUT:', error);
      alert('Erro ao finalizar serviço. Verifique o console.');
    }
  };
  
    const monthNames = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
  
    const dayNames = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
  
    const changeMonth = (direction) => {
      setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth() + direction, 1));
    };
  
    // Se não tem informações do usuário, mostrar mensagem
    if (!userInfo || !userInfo.venLogin) {
      return (
        <div className="agenda-container">
          <div className="error-message">
            <h2>Acesso não autorizado</h2>
            <p>É necessário fazer login para acessar a agenda.</p>
            <button onClick={() => navigate('/')}>Fazer Login</button>
          </div>
        </div>
      );
    }
  
    const modalAgendamento = () => {
      setshowModalAgendamento(true);
    };


  return (
    <>
      <header className="header">
        <img src={`${userInfo?.url}/imagens/${userInfo?.alias}.bmp`} alt="Logo da empresa" className='logoHeader' />
        <h2>Bem-vindo, {userInfo?.username}!</h2>
        <h1>Relatório CRM {userInfo?.company}</h1>
      </header>

      <Link to="/menu" className="link-style">Voltar ao menu</Link>

      <div className="botao-container">
        <button className="btn-container" onClick={() =>setAbaSelecionada('analiseClientes')}>Analise de Clientes</button>
        <button className="btn-container" onClick={() => setAbaSelecionada('analiseVendas')}>Analise de Vendas</button>
        <button className="btn-container" onClick={() => setAbaSelecionada('analiseProdutos')}>Analise de Produtos</button>
        {userInfo.agenda === 'T' && (
          <button className="btn-container" onClick={() => { setAbaSelecionada('agenda'); fetchAgendamentos(); }}>Agenda</button>
        )}
      </div>

       {/* Filtros e Tabela */}
       {abaSelecionada === 'analiseClientes' && (
        <div>
          <div className="crm-container">
              <div className="crm-filtros">
                  <h3>Filtros</h3>

                      <div className="detail-item">
                          <label>Cliente:</label>
                          <div className="cliente-box">
                          <input
                          type="text"
                          placeholder="Pesquisar cliente..."
                          value={selectedCliente ? selectedCliente.colFantasia : searchTerm}
                          onChange={(e) => {
                              setSelectedCliente(null);
                              setShowSuggestions(true);
                              setSearchTerm(e.target.value);
                          }}
                          onFocus={() => setShowSuggestions(true)}
                          />
                          {searchTerm && (
                              <button
                              className="clear-button"
                              title="Limpar pesquisa"
                              onClick={() => {
                                  setSearchTerm('');
                                  setSelectedCliente(null);
                                  setShowSuggestions(false); // ou true, se quiser manter a lista aberta
                              }}
                              >
                              ❌
                              </button>
                          )}

                          {/* 🔹 Lista de sugestões (só aparece se showSuggestions for true) */}
                          {showSuggestions && searchTerm && (
                              <ul className="cliente-list">
                              {filteredClientes.length > 0 ? (
                                  filteredClientes.map((c, index) => (
                                  <li key={`${c.cliId}-${index}`} onClick={() => handleSelectCliente(c)}>
                                      {c.cliId} - <strong>{c.colNome}</strong> <br /> {c.colFantasia}
                                  </li>
                                  ))
                              ) : (
                                  <li>❌ Nenhum cliente encontrado</li>
                              )}
                              </ul>
                          )}
                          </div>
                      </div>

                      <div clasName="filtros-item"> 
                        <div className="detail-item-txt">
                            <label>Rota:</label>
                            <input type="text" value={filterRota} onChange={e => setFilterRota(e.target.value)} placeholder="Filtrar rota..." />
                        </div>

                        <div className="detail-item-selecao">
                            <label>Status Cliente:</label>
                            <select value={filterStatusCli} onChange={e => setFilterStatusCli(e.target.value)}>
                                <option value="">Todos</option>
                                <option value="Ativo">Ativo</option>
                                <option value="Bloqueado">Bloqueado</option>
                            </select>
                        </div>

                        <div className="detail-item-selecao">
                            <label>Financeiro:</label>
                            <select value={filterStatusFin} onChange={e => setFilterStatusFin(e.target.value)}>
                                <option value="">Todos</option>
                                <option value="Ativo">Ativo</option>
                                <option value="Bloqueado">Bloqueado</option>
                            </select>
                        </div>

                        <div className="detail-item-txt">
                            <label>Dias s/ Compra (maior que):</label>
                            <input type="number" value={filterDias} onChange={e => setFilterDias(e.target.value)} />
                        </div>

                        <div className="detail-item-selecao">
                            <label>Positivo:</label>
                            <select value={filterPositivo} onChange={e => setFilterPositivo(e.target.value)}>
                                <option value="">Todos</option>
                                <option value="Sim">Sim</option>
                                <option value="Nao">Não</option>
                            </select>
                        </div>

                        <div className="detail-item-selecao">
                            <label>Vendedor:</label>
                            <select value={filterVendedor} onChange={e => setFilterVendedor(e.target.value)}>
                                <option value="">Todos</option>
                                {vendedorAnalise.map((vendedor) => (
                                    <option key={vendedor.venId} value={vendedor.venId}>
                                      {vendedor.vendedor}
                                    </option>
                                  ))}
                            </select>
                        </div>
                      </div>

                      <button className="btn-print-crm" onClick={gerarPDF} style={{ marginTop: '20px' }}>🖨️ Imprimir Relatório</button>
                  </div>
                  
              </div>
              
              <div className="crm-tabela">
                  <h3>Clientes</h3>
                  {loading ? (<div className="loading-container" tabIndex={-1}>
                    <img src={logo} alt="Logo" className="loading-logo" />
                    <p>Carregando dados, aguarde...</p>
                  </div>
                  ): (
                  <table>
                      <thead>
                          <tr>
                              <th>ID</th>       
                              <th>Nome</th>       
                              <th>Rota</th>
                              <th>Limite de Crédito</th>
                              <th>Credito Utilizado</th>
                              <th>Status do Cliente</th>
                              <th>Status do Financeiro</th>
                              <th>Dias sem Compra</th>
                              <th>Cliente Positivo</th>
                              <th>id Vendedor</th>
                              <th>Vendedor</th>
                          </tr>
                      </thead>
                      <tbody> 
                          {dadosFiltradosTable.map(item => (
                              <tr key={item.cliId}>
                                  <td>{item.cliId}</td>
                                  <td>{item.colNome}</td>
                                  <td>{item.cliRota || '-'}</td>
                                  <td>{item.vlrCredito?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                  <td>{item.limiteUtilizado?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                  <td>{item.statusCliente}</td>
                                  <td>{item.statusFinanceiro}</td>
                                  <td>{item.diasSemCompra}</td>
                                  <td>{item.clientePositivo}</td>
                                  <td>{item.venId}</td>
                                  <td>{item.vendedor}</td>
                              </tr>
                          ))}
                      </tbody>
                  </table>
                  )}
            </div>
          </div>
       )}

       {abaSelecionada === 'analiseVendas' && (
        <div>
          <h2>Em breve: Análise de Vendas</h2>
        </div>
       )}

       {abaSelecionada === 'analiseProdutos' && (
        <div>
          <h2>Em breve: Análise de Produtos</h2>
        </div>
       )}

       {abaSelecionada === 'agenda' && (
        <div>
          <div className="agenda-container">
            <h1>Agenda</h1>
                    <div className="agenda-header">
                      <select 
                        value={atendenteVendedor} 
                        onChange={(e) => setAtendenteVendedor(e.target.value)}
                        required
                        >
                          <option value="">Todos Atendentes</option>
                          {vendedorSelecionado.map((vendedor) => (
                            <option key={vendedor.venId} value={vendedor.nome}>
                              {vendedor.nome}
                            </option>
                          ))}
                      </select>  

                      <button className="btn-cadastro" onClick={() => modalAgendamento()}>
                        + Novo Agendamento
                      </button>
                      <button className="btn-cadastro" onClick={() => navigate('/venda')}>
                        Cadastro de Pedidos
                      </button>
                    </div>
          
                      <div className="calendar-container">
                        <div className="calendar-header">
                        <button className="nav-btn" onClick={() => changeMonth(-1)}>‹</button>
                        <h2>{monthNames[selectedDate.getMonth()]} {selectedDate.getFullYear()}</h2>
                        <button className="nav-btn" onClick={() => changeMonth(1)}>›</button>
                      </div>
          
                      <div className="calendar-grid">
                        {dayNames.map(day => (
                          <div key={day} className="day-header">{day}</div>
                        ))}
                        
                        {getDaysInMonth(selectedDate).map((day, index) => {
                          if (!day) return <div key={index} className="empty-day"></div>;
                          
                          const dateStr = formatDate(day);
                          const dayAppointments = agendamentosReais[dateStr] || [];
                          const isToday = formatDate(new Date()) === dateStr;
                          
                          // Debug: Log para verificar as datas
                          if (dayAppointments.length > 0) {
                            console.log(`Data: ${dateStr}, Agendamentos:`, dayAppointments);
                          }
                          
                          return (
                            <div key={index} className={`calendar-day ${isToday ? 'today' : ''} ${dayAppointments.length > 0 ? 'has-appointments' : ''}`}>
                              <div className="day-number">{day.getDate()}</div>
                                <div className="appointments">
                                  {dayAppointments
                                    .filter(appointment => {
                                      // Se não houver vendedor selecionado, mostra todos. 
                                      // Se houver, mostra apenas o que coincide com o nome.
                                      return atendenteVendedor === "" || appointment.vendedor === atendenteVendedor;
                                    })
                                    .map(appointment => (
                                      <div 
                                        key={appointment.id} 
                                        className={`appointment-item ${appointment.status?.toLowerCase() === 'agendado' ? 'appointment-agendado' : appointment.status?.toLowerCase() === 'finalizado' ? 'appointment-finalizado' : 'appointment-cancelado'}`}
                                        onClick={() => openModal(appointment, dateStr)}
                                      >
                                        <span className="appointment-time">{appointment.hora}</span>
                                        <span className="appointment-client">{appointment.cliente}</span>
                                        <span className="appointment-client">{appointment.atendente}</span>
                                        <span className="appointment-client">{appointment.status}</span>
                                      </div>
                                    ))
                                  }
                                  {/* Opcional: Se após filtrar não sobrar nenhum agendamento no dia */}
                                  {dayAppointments.filter(app => atendenteVendedor === "" || app.vendedor === atendenteVendedor).length === 0 && dayAppointments.length > 0 && (
                                    ''
                                  )}
                                </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
          
                    {/* Modal */}
                    {showModal && selectedAppointment && (
                      <div className="modal-overlay" onClick={closeModal}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                          <div className="modal-header">
                            <h3>Detalhes do Agendamento</h3>
                            <button className="close-btn" onClick={closeModal}>×</button>
                          </div>
                          
                          <div className="modal-body">
                            <div className="detail-item">
                              <label>Cliente:</label>
                              <span>{selectedAppointment.cliente}</span>
                            </div>
                            
                            <div className="detail-item">
                              <label>Data:</label>
                              <input 
                                type="date" 
                                name="data" // O segredo está aqui!
                                value={dadosAlteradosAgendamento.data || selectedAppointmentDate} // Mostra a data original se não houver alteração
                                onChange={(e) => {
                                  const { name, value } = e.target; // Pega "data" e o valor digitado

                                  setDadosAlteradosAgendamento((prev) => ({
                                    ...prev,
                                    [name]: value // Atualiza a chave "data" com o novo valor
                                  }));
                                }} 
                              />
                            </div>
                            
                            <div className="detail-item">
                              <label>Hora:</label>
                              <input 
                                type="time" 
                                name="hora" // O segredo está aqui!
                                value={dadosAlteradosAgendamento.hora || selectedAppointment.hora} 
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setDadosAlteradosAgendamento((prev) => ({
                                    ...prev,
                                    [name]: value
                                  }));
                                }}
                              />
                            </div>
                            
                            <div className="detail-item">
                              <label>Status:</label>
                              <span className={`status-badge ${selectedAppointment.status?.toLowerCase() === 'agendado' ? 'status-agendado' : 'status-finalizado'}`}>
                                {selectedAppointment.status}
                              </span>
                            </div>
                            
                            <div className="detail-item">
                              <label>Tipo Agendamento:</label>
                              <select 
                                className={`status-badge ${selectedAppointment.tipo?.toLowerCase() === 'telefone' ? 'status-telefone' : 'status-visita'}`}
                                name='tipo'
                                value={dadosAlteradosAgendamento.tipo || selectedAppointment.tipo}
                                onChange={(e) => {
                                  const { name, value } = e.target;   
                                  setDadosAlteradosAgendamento((prev) => ({
                                    ...prev,
                                    [name]: value
                                  }));
                                }}
                              >
                                <option value="">Selecione o status</option>
                                <option value="TELEFONE">Telefone</option>
                                <option value="VISITA">Visita</option>
                              </select>
                            </div>
          
                            <div className="detail-item">
                              <label>Motivo Agendamento:</label>
                              <select 
                                name='motivo'
                                value={dadosAlteradosAgendamento.motivo || selectedAppointment.motivo}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setDadosAlteradosAgendamento((prev) => ({
                                    ...prev,
                                    [name]: value
                                  }));
                                }}
                              >
                                <option value="">Selecione o motivo</option>
                                <option value="LEAD">LEAD</option>
                                <option value="VENDA">VENDA</option>
                                <option value="VISITA PRESENCIAL">VISITA PRESENCIAL</option>
                                <option value="VISITA TECNICA">VISITA TECNICA</option>
                              </select>
                            </div>
          
                            <div className="detail-item">
                              <label>Atendente:</label>
                                <select 
                                  name="atendente" // Certifique-se que o NAME é igual ao que você busca no payload
                                  value={dadosAlteradosAgendamento.venId || selectedAppointment.vendedorId} 
                                  onChange={(e) => {
                                    const { name, value } = e.target;
                                    setDadosAlteradosAgendamento(prev => ({ ...prev, [name]: value }));
                                  }}
                                  required
                                >
                                <option value="">Selecione o atendente</option>
                                {dadosVendedor.map((vendedor) => (
                                  <option key={vendedor.venId} value={vendedor.venId}>
                                    {vendedor.nome}
                                  </option>
                                ))}
                              </select>
                            </div>
                            
                            <div className="detail-item">
                              <label>Descrição:</label>
                              <textarea 
                                name='descricao'
                                value={dadosAlteradosAgendamento.descricao || selectedAppointment.descricao}
                                onChange={(e) => {
                                  const { name, value } = e.target;
                                  setDadosAlteradosAgendamento((prev) => ({
                                    ...prev,
                                    [name]: value
                                  }));
                                }}
                              />
                            </div>

                          {selectedAppointment.geolocalizacao && (
                            <div className="detail-item">
                              <label>Localização registrada:</label>
                              <a 
                                href={`https://www.google.com/maps/search/?api=1&query=${selectedAppointment.geolocalizacao}`} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                  color: '#4285F4',
                                  textDecoration: 'none',
                                  fontWeight: 'bold',
                                  marginTop: '5px',
                                  fontSize: '0.9rem'
                                }}
                              >
                                📍 Ver no Google Maps
                              </a>
                            </div>
                          )}                            
                          </div>
                          
                          <div className="modal-footer">
                            <button className="btn-secondary" onClick={closeModal}>
                              Voltar
                            </button>
                            <button className="btn-Cancelar" onClick={cancelarAgendamento}>
                              Cancelar
                            </button>
                            <button className="btn-Salvar" onClick={salvarAgendamento}>
                              Salvar
                            </button>
                            <button className="btn-primary" onClick={finalizarAgendamento}>
                              Finalizar
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
          
                    {/* Modal Agendamento novo */}
                    {showModalAgendamento &&(
                      <div className="modal-overlay" onClick={closeModal}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                          <div className="modal-header">
                            <h3>Novo Agendamento</h3>
                            <button className="close-btn" onClick={closeModal}>×</button>
                          </div>
                          
                          <div className="modal-body">
                            <div className="detail-item">
                              <label>Cliente:</label>
                              <div className="cliente-box">
                                <input
                                  type="text"
                                  placeholder="Pesquisar cliente..."
                                  value={selectedCliente ? selectedCliente.colFantasia : searchTerm}
                                  onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setSelectedCliente(null);
                                    setShowSuggestions(true);
                                  }}
                                  onFocus={() => setShowSuggestions(true)}
                                />
                                  {searchTerm && (
                                    <button
                                      className="clear-button"
                                      title="Limpar pesquisa"
                                      onClick={() => {
                                        setSearchTerm('');
                                        setShowSuggestions(false); // ou true, se quiser manter a lista aberta
                                      }}
                                    >
                                      ❌
                                    </button>
                                  )}
            
                                  {/* 🔹 Lista de sugestões (só aparece se showSuggestions for true) */}
                                  {showSuggestions && searchTerm && (
                                    <ul className="detail-item">
                                      {filteredClientes.length > 0 ? (
                                        filteredClientes.map((c, index) => (
                                          <li key={`${c.cliId}-${index}`} onClick={() => handleSelectCliente(c)}>
                                            {c.cliId} - <strong>{c.colNome}</strong> <br /> {c.colFantasia}
                                          </li>
                                        ))
                                      ) : (
                                        <li>❌ Nenhum cliente encontrado</li>
                                      )}
                                    </ul>
                                  )}
                              </div>
                            </div>
                            
                            <div className="detail-item">
                              <label>Data:</label>
                              <input
                                type="date"
                                value={dataAgendamento}
                                onChange={(e) => setDataAgendamento(e.target.value)}
                                required
                              />
                            </div>
                            
                            <div className="detail-item">
                              <label>Hora:</label>
                              <input type="time" 
                              value={horaAgendamento} 
                              onChange={(e) => setHoraAgendamento(e.target.value)}
                              required
                              />
                            </div>
                            
                            <div className="detail-item">
                              <label>Tipo Agendamento:</label>
                              <select 
                              value={ageTipoAtendimento} 
                              onChange={(e) => setAgeTipoAtendimento(e.target.value)}
                              required
                              >
                                <option value="">Selecione o status</option>
                                <option value="TELEFONE">TELEFONE</option>
                                <option value="VISITA">VISITA</option>
                              </select>
                            </div>
          
                            <div className="detail-item">
                              <label>Motivo Agendamento:</label>
                              <select 
                              value={motivoAgendamento} 
                              onChange={(e) => setMotivoAgendamento(e.target.value)}
                              required
                              >
                                <option value="">Selecione o status</option>
                                <option value="LEAD">LEAD</option>
                                <option value="VENDA">VENDA</option>
                                <option value="VISITA PRESENCIAL">VISITA PRESENCIAL</option>
                                <option value="VISITA TECNICA">VISITA TECNICA</option>
                              </select>
                            </div>
                            
                            <div className="detail-item">
                              <label>Atendente:</label>
                              <select 
                              value={vendedorCadastro} 
                              onChange={(e) => setVendedorCadastro(e.target.value)}
                              required
                              >
                                <option value="">Selecione o atendente</option>
                                {dadosVendedor.map((vendedor) => (
                                  <option key={vendedor.venId} value={vendedor.venId}>
                                    {vendedor.nome}
                                  </option>
                                ))}
                              </select>
                            </div>
                            
                            <div className="detail-item">
                              <label>Descrição:</label>
                              <textarea
                                value={descricaoAgendamento}
                                onChange={(e) => setDescricaoAgendamento(e.target.value)}
                                required
                              />
                            </div>
                          </div>
                          
                          <div className="modal-footer">
                            <button className="btn-secondary" onClick={closeModal}>
                              Voltar
                            </button>
                            <button className="btn-primary" onClick={handleAgendamentoSubmit}>
                              Enviar Agendamento
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
              </div>
          </div>
        )}       

    </>
  );
};

export default Relatorio;